module.exports = __webpack_public_path__ + "img/ledme.8030ac21.jpg";